import React from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Altijd client-side opbouwen: de prerender-HTML (voor zoekmachines) wijkt af zodra API-inhoud laadt, hydratatie zou falen (#418).
createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
